import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ItemSetting} from "../../models/itemSetting.model";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";

export class ProgramServiceAreasByPackageSizeTableRowCtrl implements IController {

  zone: any;
  serviceAreasOptionIds: string[];
  excludeLocationIds: string[];
  isExpanded: boolean;
  packagesOptionsIds: string[]
  onUpdateZone: Function;
  onDelete: Function;

  public queryPackage: string;
  public isDesktop: boolean;
  public sitePackageItems: ItemSetting[];
  public packageItemOptions: ItemSetting[];
  public usedPackagesCount: number;
  public canAddPackage: boolean;
  private quantitySettingsOptions: any;
  public quantitySettingsValues: any = {};

  /* @ngInject */
  constructor(private splitService, private pricePlanDialogService: PricePlanDialogService, private $mdMedia) {
    this.sitePackageItems = this.splitService.getSitePackageItems();
    this.isDesktop = $mdMedia('gt-md');
  }

  $onInit() {
    this.usedPackagesCount = 0;
    this.quantitySettingsOptions = ['DEFAULT', 'CUSTOM', 'PARENT'];
    this._setQuantitySettingsValues();
    this._setUsedPackagesCount();
  }

  $onChanges(changes) {
    if (changes.zone && !changes.zone.isFirstChange()) {
      this._setQuantitySettingsValues();
      this._setUsedPackagesCount();
    }
    if (changes.packagesOptionsIds && !changes.packagesOptionsIds.isFirstChange()) {
      this._setUsedPackagesCount();
    }
  }

  onQueryPackagesChange(query) {
    this.queryPackage = query;
  }

  onServiceAreaSelect(serviceArea) {

    if (!serviceArea) {
      return;
    }

    this.zone.toId = _.get(serviceArea, 'id');
    this.zone.name = _.get(serviceArea, 'areaName');
    this.updateRequired();
  }

  onOpenPackageSelect($mdMenu, $event) {
    this._setPackageItemOptions();
    $mdMenu.open();
  }

  onClosePackageSelect($mdMenu) {
    this.packageItemOptions = [];
    this.queryPackage = undefined;
    this._setUsedPackagesCount();
    $mdMenu.close();
  }

  onAddPackage(packageItem: ItemSetting) {
    this.zone.combinedPackageSizePriceDataMap[packageItem.id] = {enable: true};
    this.isExpanded = true;
    this._setUsedPackagesCount();
    this._setQuantitySettingsValues();
    this.updateRequired();
  }

  onRemovePackage(id) {
    _.unset(this.zone.combinedPackageSizePriceDataMap, id);
    this._setUsedPackagesCount();
    this._setQuantitySettingsValues();
    this.updateRequired();
  }

  onZoneChange(zone) {
    this.zone = zone;
    this.updateRequired();
  }

  changePackageStateTo(packageKey, updatedData) {
    this.zone.combinedPackageSizePriceDataMap[packageKey] = updatedData;
    this.updateRequired();
  }

  onQuantitySettingsChange(packageId, value) {
    const updatedZone = angular.copy(this.zone);

    if (!updatedZone.combinedPackageSizePriceDataMap[packageId].packageSizeSettings) {
      updatedZone.combinedPackageSizePriceDataMap[packageId].packageSizeSettings = {};
    }

    if (value === 'PARENT') {
      updatedZone.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsDefault = false;
      updatedZone.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsParent = true;
    } else if (value === 'DEFAULT') {
      updatedZone.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsDefault = true;
      updatedZone.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsParent = false;
    } else {
      updatedZone.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsDefault = false;
      updatedZone.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsParent = false;
    }

    this.zone = updatedZone;
    this.updateRequired();
  }

  onEditCustom(packageKey, $event) {
    const packageRef = angular.copy(this.zone.combinedPackageSizePriceDataMap[packageKey]);

    if (!packageRef.packageSizeSettings) {
      packageRef.packageSizeSettings = {};
    }

    if (!packageRef.quantitySetting) {
      packageRef.quantitySetting = {};
    }

    if (!packageRef.quantitySetting.quantityDiscountLines) {
      packageRef.quantitySetting.quantityDiscountLines = [];
    }

    const quantityDiscountLines = _.get(packageRef, 'quantitySetting.quantityDiscountLines', []);
    this.pricePlanDialogService.editPricePlanQuantityDiscountLines($event, quantityDiscountLines)
      .then((updatedQuantityDiscountLines) => {
        const updatedPackage = angular.copy(packageRef);
        updatedPackage.quantitySetting.quantityDiscountLines = updatedQuantityDiscountLines;
        updatedPackage.packageSizeSettings.packageSizeQuantitySettingsDefault = false;
        updatedPackage.packageSizeSettings.packageSizeQuantitySettingsParent = false;

        this.zone.combinedPackageSizePriceDataMap[packageKey] = updatedPackage;
        this.updateRequired();
      })
  }

  private _setQuantitySettingsValues() {
    _.forOwn(this.zone.combinedPackageSizePriceDataMap, (value, key) => {
      if (_.get(this.zone.combinedPackageSizePriceDataMap[key], 'packageSizeSettings.packageSizeQuantitySettingsParent', false)) {
        this.quantitySettingsValues[key] = 'PARENT';
      } else if (_.get(this.zone.combinedPackageSizePriceDataMap[key], 'packageSizeSettings.packageSizeQuantitySettingsDefault', false)) {
        this.quantitySettingsValues[key] = 'DEFAULT';
      } else {
        this.quantitySettingsValues[key] = 'CUSTOM';
      }
    })
  }

  private _setPackageItemOptions() {
    const usedIds = _.keys(this.zone.combinedPackageSizePriceDataMap);
    this.packageItemOptions = _.filter(this.sitePackageItems, (item) => {
      return _.includes(this.packagesOptionsIds, item.id) && !_.includes(usedIds, item.id);
    })
  }

  private _setUsedPackagesCount() {
    const excludeIds = _.keys(this.zone.combinedPackageSizePriceDataMap);
    this.usedPackagesCount = excludeIds.length;
    this.canAddPackage = !!_.find(this.sitePackageItems, (item) => {
      return _.includes(this.packagesOptionsIds, item.id) && !_.includes(excludeIds, item.id);
    })
  }

  private updateRequired() {
    this.onUpdateZone({zone: this.zone});
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programServiceAreasByPackageSizeTableRow', {
    bindings: {
      zone: '<',
      serviceAreasOptionIds: '<?',
      excludeServiceAreasIds: '<?',
      isExpanded: '<?',
      packagesOptionsIds: '<',
      onUpdateZone: '&',
      onDelete: '&'
    },
    template: require('./program-service-areas-by-package-size-table-row.html').default,
    controller: ProgramServiceAreasByPackageSizeTableRowCtrl
  });

